import React from 'react';
import { PanelGroup, type PanelGroupProps } from 'react-resizable-panels';
import { cn } from '../../../lib/utils';

export interface SplitPaneProps extends Omit<PanelGroupProps, 'direction'> {
  direction?: 'horizontal' | 'vertical';
  autoSaveId?: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * SplitPane - Wrapper around react-resizable-panels PanelGroup
 * Provides resizable panel layout with localStorage persistence
 */
export const SplitPane = React.forwardRef<
  React.ElementRef<typeof PanelGroup>,
  SplitPaneProps
>(({ direction = 'horizontal', autoSaveId, className, children, ...props }, ref) => {
  return (
    <PanelGroup
      ref={ref}
      direction={direction}
      autoSaveId={autoSaveId}
      className={cn('flex w-full h-full', className)}
      {...props}
    >
      {children}
    </PanelGroup>
  );
});

SplitPane.displayName = 'SplitPane';
